import { ROUTE_NAMES } from '@/lib/enums';
import { ROLE_USER } from '@/util/roles';

export const routes = [
	{
		path: 'reviews',
		meta: {
			requireAuth: true,
			breadcrumb: 'Reviews',
			// Deliberately below the /depot baseline, cascading to every child.
			// The single-review page is NOT one of them — see review.routes.ts.
			minRole: ROLE_USER,
		},
		children: [
			{
				path: '',
				name: ROUTE_NAMES.DEPOT.REVIEWS.DASHBOARD,
				component: () => {
					return import('@/views/depot/reviews/Dashboard.vue');
				},
				meta: {
					requireAuth: true,
					breadcrumb: '',
				},
			},
			{
				path: 'all-reviews',
				component: () => {
					return import('@/views/depot/reviews/Overview.vue');
				},
				name: ROUTE_NAMES.DEPOT.REVIEWS.OVERVIEW,
				meta: {
					requireAuth: true,
					breadcrumb: 'All Reviews',
				},
			},
			{
				path: 'insights',
				component: () => {
					return import('@/views/depot/reviews/Insights.vue');
				},
				name: ROUTE_NAMES.DEPOT.REVIEWS.INSIGHTS,
				meta: {
					requireAuth: true,
					breadcrumb: 'AI Insights',
				},
			},
		],
	},
];
